import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { DialogService, eDialogType } from '@ds/ng-wt-dialog';
import { Constants } from '../../shared/providers/data';
import { LocalstorageService } from '../../shared/providers/localstorage.service';
import { SettingLoginComponent } from '../app-settings/component/setting-login/setting-login.component';
import { AuthService } from '../authentication/auth.service';
import { SettingsHelperService } from '../app-settings/services/settings-helper.service';
import { AppSettingsService } from '@ds/ng-wt-app-settings';
import { LoginService } from './services/login.service';
import { LoginDetailsService } from './services/login-details.service';
import { NgToastTranslocoService } from 'src/app/common/services/ng-toast-transloco/ng-toast-transloco.service';
import { ContentsService } from 'src/app/shared/services/contents.service';
import { CountryStatesDataService } from 'src/app/shared/services/country-states-data.service';
import { AwsCredentialsData } from './interfaces/login-details.interface';
import { LoginState } from './enums/login_state';
import { SignUpStatus } from './components/signup/signup.component';
import { PlayerIdValidator } from '../custom-validators/playerIdValidator';
import { ExistingPlayerErrors } from './constants/existing.player.errors';
import { LoaderService } from 'src/app/common/services/loader/loader.service';
import { ConfirmationAlertDialogComponent } from 'src/app/core/login/components/confirmation-alert-dialog/confirmation-alert-dialog.component';
import { emailPattern, encryptionKey } from 'src/app/const/constant';
import { ConfigurationsService } from 'src/app/modules/configurations/services/configurations.service';
import { firstValueFrom } from 'rxjs';

interface LoginDetails {
  username: string;
  password: string;
}

@Component({
  selector: 'ds-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, AfterViewInit {
  @ViewChild('myDiv') myDiv: ElementRef;
  @ViewChild('particleContainer') particleContainer: ElementRef;
  @ViewChild('otp1') otp1: any;
  @ViewChild('otp2') otp2: any;
  @ViewChild('otp3') otp3: any;
  @ViewChild('otp4') otp4: any;
  @ViewChild('otp5') otp5: any;
  @ViewChild('otp6') otp6: any;

  loginBG = {
    showColor: false,
    showImage: false,
    showVideo: false,
    backgroundColor: '',
    backgroundImage: '',
    backgroundVideo: '',
  };
  logoData;
  showDescription = false;

  loginState: LoginState = LoginState.SignIn;

  LoginStateEnum = LoginState;
  desktopBgImage: any;
  tabletBgImage: any;
  mobileBgImage: any;
  hasPhonenumber: boolean = false;
  hasMail: boolean = false;
  phoneNumber: any;

  switchState(newState: LoginState, isRegisterClick: boolean = false) {
    this.loginState = newState;
    if (isRegisterClick) {
      this.username.setValue('');
    }
  }

  showPasswords = false;
  showPassword = false;
  showConfirmPassword = false;
  showPin = false;
  showOTPScreen: boolean = false;
  emailShow: any;
  loginForm!: FormGroup;
  userLoginDetails: LoginDetails = { username: '', password: '' };
  showBranding: boolean = false;
  otpCode: any;
  isCmsRegistrationPending: boolean = false;
  forgotPasswordInvoked: boolean = false;
  changePasswordInvoked: boolean = false;
  newPlayerRegistrationInvoked: boolean = false;
  existingPlayerRegistrationInvoked: boolean = false;
  resetPasswordUsername: string = '';
  maskedEmail: string = '';
  resendConfirmationCode: boolean = false;
  appContentsList: any;
  countryAndStatesData: { key: string; name: any; states: any[] }[];
  identTypeArray: any;
  termsUrl: any;
  selectedCountry: { key: string; name: any; states: any[] };
  selectedState: null;
  userdata: any;
  awsCredentials: AwsCredentialsData;
  get maskedEmailId(): string {
    if (!this.emailId || typeof this.emailId !== 'string') return '';
    const [name, domain] = this.emailId.split('@');
    if (!name || !domain) return this.emailId;
    const maskedName =
      name.length <= 2
        ? name[0] + '*'
        : name.length === 3
          ? name[0] + '*' + name[2]
          : name[0] + '*'.repeat(name.length - 3) + name.slice(-2);
    return `${maskedName}@${domain}`;
  }

  get maskedPhoneNumber(): string {
    if (!this.phoneNumber || typeof this.phoneNumber !== 'string') return '';
    // Mask all but last 2 digits
    const len = this.phoneNumber.length;
    if (len <= 2) return '*'.repeat(len);
    return '*'.repeat(len - 2) + this.phoneNumber.slice(-2);
  }
  addresstype: any;
  EmailType: any;
  phoneType: any;
  formattedDob: string;
  formatteexpiryDate: string;
  formatteissuedDate: string;
  maxDate: Date;
  maxIssuedDate: Date;
  minExpiryDate: Date;
  existingPlayerForm: FormGroup;
  existingPlayer: boolean = false;
  payloadvalue: any;
  otpFormExisiting: FormGroup;
  existingPlayerOtp: boolean = false;
  emailId: any;
  accountlinkform: FormGroup;
  directAccountLinkForm!: FormGroup;
  account: any;
  accountlink: boolean = false;
  supportOtpValidationForPlayerLinking: boolean = true;
  isEnableOtp: boolean = false;
  isEnableSignUp: boolean = true;
  isEnableMfaSetupDirectly: boolean = false;
  userEnteredEmail: string = '';
  userEnteredPassword: string = '';
  isPasswordResetFlow: boolean = false;
  isEmailConfirmationFlow: boolean = false;
  isOtpVerificationOnly: boolean = false;
  appPlayerManagementSystemAttributes: any;
  headerImage: any;
  supportNewPlayerRegistration: boolean = false;

  // Account unlock OTP flow
  isAccountUnlockFlow: boolean = false;
  unlockIdentifier: string = '';
  isUnlockByEmail: boolean = false;

  // MFA properties
  mfaChallengeType: string = ''; // 'SELECT_MFA_TYPE', 'SMS_MFA', 'SOFTWARE_TOKEN_MFA'
  mfaChallengeParameters: any = {};
  mfaSession: string = '';
  selectedMfaMethod: 'SMS' | 'TOTP' = 'SMS';
  mfaOtpForm!: FormGroup;
  mfaPhoneNumber: string = '';
  mfaEmail: string = '';

  // MFA Reset OTP properties
  mfaResetOtpForm!: FormGroup;
  mfaResetEmail: string = '';
  mfaResetUsername: string = '';
  mfaResetPassword: string = '';

  // New Password Required properties
  newPasswordForm!: FormGroup;
  newPasswordUsername: string = '';

  constructor(
    public route: Router,
    public authService: AuthService,
    public constants: Constants,
    private appSettingService: AppSettingsService,
    public cdr: ChangeDetectorRef,
    private dsDialog: DialogService,
    private settingHelper: SettingsHelperService,
    private loginService: LoginService,
    private loginDetailsService: LoginDetailsService,
    private fb: FormBuilder,
    private toast: NgToastTranslocoService,
    private countryAndStatesDataService: CountryStatesDataService,
    private localStorageService: LocalstorageService,
    private loaderService: LoaderService,
    private contentService: ContentsService,
    private configurationService: ConfigurationsService,
  ) { }

  async ngOnInit() {
    this.init();
    this.supportNewPlayerRegistration =
      this.loginDetailsService.supportNewPlayerRegistration;
    this.supportOtpValidationForPlayerLinking =
      this.loginDetailsService.supportOTPValidationForPlayerLinking ?? true;
    this.headerImage = this.loginDetailsService?.headerImage
      ? this.loginDetailsService.headerImage
      : '';
    if (this.authService.canNavigateToDashboard) {
      this.authService.navigateToDashboard();
    }
  }

  private init() {
    this.getAppConfigList();
    this.changeBackground();

    this.loginForm = new FormGroup({
      username: new FormControl(this.userLoginDetails.username, [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(50),
        LoginComponent.accountNumberOrEmailValidator(),
      ]),
      password: new FormControl(this.userLoginDetails.password, [
        Validators.required,
        Validators.minLength(1),
        Validators.pattern(/^\S*$/),
      ]),
    });

    this.getLoginInitData();
    this.onLoginBGChanged();
    this.onLangChange('en');

    this.existingPlayerForm = this.fb.group({
      accountNumber: [
        '',
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(50),
        ],
      ],
    });
    this.otpFormExisiting = this.fb.group({
      otp1: ['', [Validators.required, Validators.pattern('[0-9]')]],
      otp2: ['', [Validators.required, Validators.pattern('[0-9]')]],
      otp3: ['', [Validators.required, Validators.pattern('[0-9]')]],
      otp4: ['', [Validators.required, Validators.pattern('[0-9]')]],
      otp5: ['', [Validators.required, Validators.pattern('[0-9]')]],
      otp6: ['', [Validators.required, Validators.pattern('[0-9]')]],
    });
    this.accountlinkform = new FormGroup({
      playerPin: new FormControl('', [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(100),
        Validators.pattern(/^\d{4}$/), // Maximum length of 100
      ]),
      acceptTerms: new FormControl(false, [Validators.requiredTrue]),
    });

    this.directAccountLinkForm = new FormGroup({
      accountNumber: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(50),
        Validators.pattern(/^[A-Za-z0-9]+$/),
      ]),
      playerPin: new FormControl('', [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(100),
        Validators.pattern(/^\d{4}$/),
      ]),
      acceptTerms: new FormControl(false, [Validators.requiredTrue]),
    });

    // Initialize MFA OTP form
    this.mfaOtpForm = this.fb.group({
      otp1: ['', [Validators.required, Validators.pattern('[0-9]')]],
      otp2: ['', [Validators.required, Validators.pattern('[0-9]')]],
      otp3: ['', [Validators.required, Validators.pattern('[0-9]')]],
      otp4: ['', [Validators.required, Validators.pattern('[0-9]')]],
      otp5: ['', [Validators.required, Validators.pattern('[0-9]')]],
      otp6: ['', [Validators.required, Validators.pattern('[0-9]')]],
    });

    // Initialize MFA Reset OTP form
    this.mfaResetOtpForm = this.fb.group({
      otp1: ['', [Validators.required, Validators.pattern('[0-9]')]],
      otp2: ['', [Validators.required, Validators.pattern('[0-9]')]],
      otp3: ['', [Validators.required, Validators.pattern('[0-9]')]],
      otp4: ['', [Validators.required, Validators.pattern('[0-9]')]],
      otp5: ['', [Validators.required, Validators.pattern('[0-9]')]],
      otp6: ['', [Validators.required, Validators.pattern('[0-9]')]],
    });

    // Initialize New Password form
    this.newPasswordForm = this.fb.group({
      newPassword: ['', [
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_+=\-{}[\]:;"'<>,.?/\\|`~])[A-Za-z\d@$!%*?&#^()_+=\-{}[\]:;"'<>,.?/\\|`~]{8,}$/)
      ]],
      confirmPassword: ['', [Validators.required]]
    }, { validators: this.passwordMatchValidator() });

    const value = history?.state ? history?.state?.register : false;
    if (value) {
      this.handleAccountEmailUnlink(value);
    }
  }

  changeBackground() {
    const resizeObserver = new ResizeObserver(() => {
      this.updateBackgroundImage();
    });

    resizeObserver.observe(document.body);
  }

  updateBackgroundImage(): void {
    const loginBgElement = document.getElementById('loginBg');
    if (loginBgElement) {
      const url = `url('${this.getDeviceTypeImg()}')`;
      loginBgElement.style.backgroundImage = url;
    }
  }

  getDeviceTypeImg(): string {
    const width = window.innerWidth;

    if (width <= 768) {
      return this.mobileBgImage;
    } else if (width > 768 && width <= 1024) {
      return this.tabletBgImage;
    } else {
      return this.desktopBgImage;
    }
  }

  get accountNumber() {
    return this.existingPlayerForm.get('accountNumber');
  }
  get playerPin() {
    return this.accountlinkform.get('playerPin');
  }

  get directAccountNumber() {
    return this.directAccountLinkForm.get('accountNumber');
  }

  get directPlayerPin() {
    return this.directAccountLinkForm.get('playerPin');
  }

  get loginEmailAddress() {
    return this.username.value || this.emailShow;
  }

  get maskedLoginEmailAddress(): string {
    let email = this.username.value || this.emailShow;
    if (email && email.includes('@')) {
      return this.maskEmail(email);
    }
    // Fallback to email cached in localStorage (set during sign-in)
    const cachedEmail = localStorage.getItem('EMAIL');
    if (cachedEmail) {
      return this.maskEmail(cachedEmail);
    }
    return email || '';
  }

  private maskEmail(username: string): string {
    if (!username || username.trim() === '' || !username.includes('@')) {
      return username;
    }

    try {
      const atIndex = username.indexOf('@');
      if (atIndex <= 2) {
        return username; // Not enough characters to mask
      }

      const maskedPart = '*'.repeat(atIndex - 2);
      const result =
        username.substring(0, 1) + maskedPart + username.substring(atIndex - 1);
      return result;
    } catch (e) {
      console.error(e);
      return username;
    }
  }

  static emailDomainValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const email = control.value;
      if (email) {
        if (!emailPattern.test(email)) {
          return { domainInvalid: true };
        }
      }
      return null;
    };
  }

  static accountNumberOrEmailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null;
      }

      // Check if it's a valid account number (only digits, minimum 3 digits)
      const accountNumberPattern = /^\d{3,}$/;
      const isAccountNumber = accountNumberPattern.test(value);

      // Check if it's a valid email
      const isEmail = emailPattern.test(value);

      // Must be either a valid account number OR a valid email
      if (!isAccountNumber && !isEmail) {
        return { invalidFormat: true };
      }

      return null;
    };
  }

  validatePassword(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) {
      return { required: true };
    }
    if (value.length < 8) {
      return { minlength: { requiredLength: 8, actualLength: value.length } };
    }
    const hasUpperCase = /[A-Z]/.test(value);
    const hasAtSymbol = /@/.test(value);
    const hasNumber = /\d/.test(value);

    if (!hasUpperCase || !hasAtSymbol || !hasNumber) {
      return { passwordStrength: true };
    }
    return null;
  }

  passwordMatchValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const newPassword = group.get('newPassword')?.value;
      const confirmPassword = group.get('confirmPassword')?.value;

      if (!newPassword || !confirmPassword) {
        return null;
      }

      return newPassword === confirmPassword ? null : { passwordMismatch: true };
    };
  }

  getAppConfigList() {
    this.termsUrl = this.loginDetailsService.termsUrl;
    this.desktopBgImage = this.loginDetailsService.desktopBgImage;
    this.tabletBgImage = this.loginDetailsService.tabletBgImage;
    this.mobileBgImage = this.loginDetailsService.mobileBgImage;
    this.identTypeArray = this.loginDetailsService.identTypeArray;
    this.addresstype = this.loginDetailsService.addressType;
    this.EmailType = this.loginDetailsService.emailType;
    this.appPlayerManagementSystemAttributes =
      this.loginDetailsService.appPlayerManagementSystemAttributes;
    this.phoneType = this.loginDetailsService.phoneType;

    this.getCountryAndStatesData();
  }

  async getCountryAndStatesData() {
    try {
      const countryResponse =
        await this.countryAndStatesDataService.fetchCountryAndStatesData();

      if (!countryResponse || typeof countryResponse !== 'object') {
        throw new Error('Invalid API response');
      }

      this.countryAndStatesData = Object.entries(countryResponse)
        .map((responseItem) => {
          if (!responseItem[1] || typeof responseItem[1] !== 'object') {
            return null;
          }

          let countryObj = {
            key: responseItem[0],
            name: responseItem[1]['name'] ?? '',
            states: [],
          };

          let divisions = responseItem[1]['divisions'];
          if (!divisions || typeof divisions !== 'object') {
            return countryObj;
          }

          countryObj.states = Object.keys(divisions).map((stateItemKey) => ({
            key: stateItemKey,
            name: divisions[stateItemKey] ?? '',
          }));

          return countryObj;
        })
        .filter(Boolean); // Removes null entries
    } catch (error) {
      console.error('Error fetching country and state data:', error);
    }
  }

  onCountryChange(selectedCountryKey: string) {
    // Update the selected country and reset the state
    this.selectedCountry = this.countryAndStatesData.find(
      (country) => country.key === selectedCountryKey
    );
    this.selectedState = null; // Reset state when country is changed
  }

  showNewPlayerRegistration() {
    this.isCmsRegistrationPending = true;
    this.existingPlayer = false;
    this.existingPlayerOtp = false;
    this.accountlink = false;
    this.isAccountUnlockFlow = false;
    this.showOTPScreen = false;
    this.newPlayerRegistrationInvoked = true;
  }

  exPlayer() {
    const accountNumber = this.existingPlayerForm.value.accountNumber?.trim();
    if (!accountNumber) {
      this.toast.toastError('MODULES.LOGIN.ENTER_ACCOUNT_NUMBER');
      return;
    }
    if (this.existingPlayerForm.valid) {
      this.payloadvalue = accountNumber;
      this.loginService.getPlayerId(this.payloadvalue);

      const payload = {
        metadata: this.loginDetailsService.getMetaData(),
      };
      this.loaderService.setLoaderStateActive(true, 'cognito_service_url');
      this.loginService
        .existingPlayer(payload)
        .then((response: any) => {
          this.loaderService.setLoaderStateActive(false, 'cognito_service_url');
          this.emailId = response?.emailId;
          this.hasMail = response?.emailId === null || response?.emailId === undefined || response?.emailId === '' ? false : true;
          this.hasPhonenumber =
            response?.phoneNumber === null ||
              response?.phoneNumber === undefined ||
              response?.phoneNumber === ''
              ? false
              : true;
          this.phoneNumber = response?.phoneNumber;
          this.existingPlayerOtp = true;
          this.isCmsRegistrationPending = false;
          this.newPlayerRegistrationInvoked = false;
          this.accountlink = false;
          this.existingPlayer = false;
          this.showOTPScreen = false;
          this.account = response.playerId;
        })
        .catch((error: any) => {
          let errorCode = error.error?.code;

          switch (errorCode) {
            case ExistingPlayerErrors.account_link_otp_country_code_not_found:
              this.toast.toastError(
                'MODULES.EXISTINGPLAYERLINKING.OTP_COUNTRY_CODE_NOT_FOUND'
              );
              break;
            case ExistingPlayerErrors.account_link_phone_number_email_id_not_available:
              this.toast.toastError(
                'MODULES.EXISTINGPLAYERLINKING.PHONENUMBER_EMAILID_NOT_AVAILABLE'
              );
              break;
            case ExistingPlayerErrors.player_account_not_available_code:
              this.toast.toastError(
                'MODULES.EXISTINGPLAYERLINKING.PLAYER_ACCOUNT_NOT_AVAILABLE'
              );
              break;
            case ExistingPlayerErrors.account_link_invalid_otp_retry_limit_exceeded:
              this.toast.toastError(
                'MODULES.EXISTINGPLAYERLINKING.OTP_MAX_RETRY_ERROR'
              );
              break;
            case ExistingPlayerErrors.duplicate_account_number_found:
              this.toast.toastError(
                'MODULES.EXISTINGPLAYERLINKING.DUPLICATE_ACCOUNT_NUMBER_FOUND'
              );
              break;
            default:
              this.toast.toastError(
                'MODULES.EXISTINGPLAYERLINKING.OTP_GENERATION_ERROR'
              );
              break;
          }
          // Keep the account number value when errors occur
          // this.existingPlayerForm.reset();
        });
    } else {
      this.toast.toastError('MODULES.LOGIN.FORM_INVALID');
    }
  }

  Cancel() {
    this.existingPlayer = false;
    this.isCmsRegistrationPending = false;
  }

  async exOtpConform() {
    if (!this.otpFormExisiting) {
      this.toast.toastError('MODULES.LOGIN.OTP_FORM');
      return;
    }
    const otp1 = this.otpFormExisiting.controls['otp1']?.value;
    const otp2 = this.otpFormExisiting.controls['otp2']?.value;
    const otp3 = this.otpFormExisiting.controls['otp3']?.value;
    const otp4 = this.otpFormExisiting.controls['otp4']?.value;
    const otp5 = this.otpFormExisiting.controls['otp5']?.value;
    const otp6 = this.otpFormExisiting.controls['otp6']?.value;
    if (!otp1 || !otp2 || !otp3 || !otp4 || !otp5 || !otp6) {
      this.toast.toastError('MODULES.LOGIN.OTP_ENTERY');
      return;
    }
    this.otpCode = `${otp1}${otp2}${otp3}${otp4}${otp5}${otp6}`;
    const payload = {
      otp: this.otpCode,
    };
    if (this.isAccountUnlockFlow) {
      this.loaderService.setLoaderStateActive(
        true,
        'otp_validation_service_url'
      );
      try {
        await this.loginService.validateUnlockOtp(
          this.otpCode,
          this.unlockIdentifier,
          this.isUnlockByEmail
        );
        this.loaderService.setLoaderStateActive(
          false,
          'otp_validation_service_url'
        );
        this.toast.toastSuccess('MODULES.LOGIN.ACCOUNT_UNLOCK_SUCCESS');
        this.isAccountUnlockFlow = false;
        this.existingPlayerOtp = false;
        this.otpFormExisiting.reset();
        this.switchState(LoginState.SignIn);
      } catch (error: any) {
        this.loaderService.setLoaderStateActive(
          false,
          'otp_validation_service_url'
        );
        const msg = error?.error?.message || 'MODULES.LOGIN.GENERIC_ERROR';
        this.toast.toastError(msg);
      }
      return;
    }
    this.loaderService.setLoaderStateActive(true, 'otp_validation_service_url');
    this.loginService
      .validateTOtp(payload)
      .then((_response: any) => {
        this.loaderService.setLoaderStateActive(
          false,
          'otp_validation_service_url'
        );
        this.isCmsRegistrationPending = false;
        this.existingPlayer = false;
        this.existingPlayerOtp = false;
        this.accountlink = true;
      })
      .catch((error: any) => {
        let errorMessage =
          error.error?.message ||
          'An unexpected error occurred. Please try again later.';
        this.toast.toastError(errorMessage);
      });
  }

  moveToNext(
    event: KeyboardEvent,
    nextField: HTMLInputElement,
    prevField: HTMLInputElement
  ): void {
    const input = event.target as HTMLInputElement;

    // Move to the next field if a character is entered
    if (input.value.length === 1 && nextField) {
      nextField.focus();
    }

    // Move to the previous field if backspace is pressed and the current field is empty
    if (event.key === 'Backspace' && input.value.length === 0 && prevField) {
      prevField.focus();
    }
  }

  accountLink() {
    const playerId = this.existingPlayerForm?.value?.accountNumber?.trim();
    const pin = this.accountlinkform?.value?.playerPin;
    const acceptTerms = this.accountlinkform?.value?.acceptTerms;

    this.submitAccountLink(playerId, pin, acceptTerms);
  }

  accountLinkWithoutOtp() {
    if (this.directAccountLinkForm.invalid) {
      this.directAccountLinkForm.markAllAsTouched();

      if (!this.directAccountLinkForm.value.accountNumber) {
        this.toast.toastError('MODULES.LOGIN.ACCOUNT_NUMBER_EMPTY');
      } else if (!this.directAccountLinkForm.value.playerPin) {
        this.toast.toastError('MODULES.LOGIN.GENERIC_ACCOUNT_PIN');
      } else if (this.directPlayerPin?.hasError('pattern')) {
        this.toast.toastError('MODULES.LOGIN.PIN_NUMBER_PATTERN');
      } else if (!this.directAccountLinkForm.value.acceptTerms) {
        this.toast.toastError('MODULES.LOGIN.ACCEPT_TERMS_ERROR');
      }
      return;
    }

    const playerId = this.directAccountLinkForm?.value?.accountNumber?.trim();
    const pin = this.directAccountLinkForm?.value?.playerPin;
    const acceptTerms = this.directAccountLinkForm?.value?.acceptTerms;

    this.submitAccountLink(playerId, pin, acceptTerms);
  }

  private submitAccountLink(
    playerId: string,
    pin: string,
    acceptTerms: boolean
  ) {
    if (!playerId) {
      this.toast.toastError('MODULES.LOGIN.ACCOUNT_NUMBER_EMPTY');
      return;
    }

    if (!pin) {
      this.toast.toastError('MODULES.LOGIN.GENERIC_ACCOUNT_PIN');
      return;
    }

    if (!/^\d{4}$/.test(pin)) {
      this.toast.toastError('MODULES.LOGIN.PIN_NUMBER_PATTERN');
      return;
    }

    if (!acceptTerms) {
      this.toast.toastError('MODULES.LOGIN.ACCEPT_TERMS_ERROR');
      return;
    }

    this.loginService.getPlayerId(playerId);
    this.payloadvalue = pin;
    const payload = {
      metadata: this.loginDetailsService.getMetaData(),
      data: {
        playerIdType: 'PatronNumber',
        pinNumber: this.payloadvalue, // Adding the player pin value from the form input
      },
    };

    this.loaderService.setLoaderStateActive(true, 'account_link_service_url');
    this.loginService
      .validatePin(payload)
      .then((response: any) => {
        const msg = this.toast.gettransloco('MODULES.LOGIN.REGISTRATION_SUCCESSFULL');
        this.toast.toastSuccessMsg(msg + ' ' + response.playerId);
        this.loginDetailsService.setPlayerId(playerId);
        this.loaderService.setLoaderStateActive(
          false,
          'account_link_service_url'
        );
        this.authService.navigateToDashboard();
      })
      .catch((err: any) => {
        this.loaderService.setLoaderStateActive(
          false,
          'account_link_service_url'
        );
        const error = err?.error;
        const accountLinkError = error?.errors?.[0] ?? error;
        const errorToastKey = this.getAccountLinkErrorToastKey(accountLinkError);

        this.toast.toastError(errorToastKey);

        const pinAttemptsLeft = accountLinkError?.pinAttemptsLeft;
        if (pinAttemptsLeft !== undefined) {
          const attemptsMessage = this.toast
            .gettransloco('MODULES.LOGIN.PIN_ATTEMPTS_LEFT')
            .replace('{{count}}', String(pinAttemptsLeft));
          // this.toast.toastWarningMsg(attemptsMessage);
        }
      });
  }

  private getAccountLinkErrorToastKey(error: any): string {
    const errorCode = error?.code || error?.ErrorCode || error?.errorCode;
    const errorMessage = (error?.message || '').trim().toLowerCase();

    switch (errorCode) {
      case 'PI0377':
        return 'MODULES.LOGIN.PLAYER_PIN_LOCKED';
      case 'PI0324':
        return 'MODULES.LOGIN.PIN_DOES_NOT_MATCH';
      case 'PI0150':
        return 'MODULES.LOGIN.PLAYER_NOT_FOUND';
      default:
        break;
    }

    switch (errorMessage) {
      case 'player pin locked.':
        return 'MODULES.LOGIN.PLAYER_PIN_LOCKED';
      case 'pin does not match':
        return 'MODULES.LOGIN.PIN_DOES_NOT_MATCH';
      case 'player not found.':
        return 'MODULES.LOGIN.PLAYER_NOT_FOUND';
      default:
        return 'MODULES.LOGIN.ACCOUNT_NUMBER_GENERIC_MESSAGE';
    }
  }

  private openAccountLinkingFlow() {
    this.switchState(LoginState.ExistingPlayerLinking);
    this.isCmsRegistrationPending = false;
    this.newPlayerRegistrationInvoked = false;
    this.existingPlayerOtp = false;
    this.isAccountUnlockFlow = false;

    if (this.supportOtpValidationForPlayerLinking) {
      this.existingPlayer = true;
      this.accountlink = false;
      this.accountlinkform.reset();
      return;
    }

    this.existingPlayer = false;
    this.accountlink = true;
    this.directAccountLinkForm.reset();
  }

  cancelAccountLinking() {
    if (this.supportOtpValidationForPlayerLinking) {
      this.backToAccount();
      return;
    }
    this.logOut();
  }

  ngAfterViewInit() {
    this.myDiv.nativeElement.addEventListener('click', () => {
      if (this.showBranding) {
        this.showBranding = false;
      }
    });
  }

  get username() {
    return this.loginForm.get('username')!;
  }

  get password() {
    return this.loginForm.get('password')!;
  }

  get newPassword() {
    return this.newPasswordForm.get('newPassword')!;
  }

  get confirmPassword() {
    return this.newPasswordForm.get('confirmPassword')!;
  }

  handleSignupCompleted(status: SignUpStatus) {
    this.isEnableMfaSetupDirectly = false;
    if (status && status.isSuccess) {
      // If this is OTP verification only (from forgot password flow), just show sign-in screen
      if (this.isOtpVerificationOnly) {
        this.isOtpVerificationOnly = false;
        this.showLogin();
        return;
      }

      // If this is password reset or email confirmation flow, user is already logged in from OTP verification
      // Just navigate to dashboard (handled automatically by authService.signIn() in signup component)
      if (this.isPasswordResetFlow || this.isEmailConfirmationFlow) {
        this.isPasswordResetFlow = false;
        this.isEmailConfirmationFlow = false;
        // User is already signed in via authService.signIn() in signup component
        // Dashboard navigation is handled automatically by signIn method
      } else {
        // Normal signup flow - show player linking
        this.emailShow = status.email;
        this.openAccountLinkingFlow();
      }
    }
  }

  public async signin() {
    this.switchState(LoginState.SignIn);
    this.forgotPasswordInvoked = false;
    this.changePasswordInvoked = false;
    this.isCmsRegistrationPending = false;
    this.existingPlayer = false;
    if (!this.username.value || !this.password.value) {
      this.loginForm.markAllAsTouched();
      this.cdr.detectChanges();
      return;
    }

    if (!this.loginForm.valid) {
      this.loginForm.markAllAsTouched();
      this.cdr.detectChanges();
      return;
    }
    try {
      // Call getCognitoUserInfo API to get encrypted username
      let usernameToUse = this.username.value;
      await this.contentService.getContentsAndConfigurationsData();
      // Check if AWS credentials are available before calling getCognitoUserInfo
      const awsCredentials =
        await this.loginDetailsService.getAwsSignatureAuthorizationConfig();
      let decryptEmail = null;
      if (awsCredentials && awsCredentials.AccessKey) {
        try {
          this.loaderService.setLoaderStateActive(true, 'get_cognito_user_info_service_url');

          const cognitoUserInfo: any =
            await this.loginService.getCognitoUserInfo(this.username.value);
          /* this.loaderService.setLoaderStateActive(
            true,
            'data_url'
          ); */
          this.loaderService.setLoaderStateActive(false, 'get_cognito_user_info_service_url');
          if (cognitoUserInfo && cognitoUserInfo.Username) {
            // Decrypt the Username using the encryption key
            const decryptedUsername = await this.authService.decryptAes256Gcm(
              cognitoUserInfo.Username,
              encryptionKey
            );
            decryptEmail = await this.authService.decryptAes256Gcm(
              cognitoUserInfo.Email,
              encryptionKey
            );
            usernameToUse = decryptedUsername;
            localStorage.setItem('guid_email', usernameToUse);
          }
        } catch (error) {
          this.loaderService.setLoaderStateActive(false, 'get_cognito_user_info_service_url');

          // If API call fails or returns null, use the original username
          console.warn(
            'getCognitoUserInfo failed, using original username:',
            error
          );
        }
      }
      this.loaderService.setLoaderStateActive(
        true,
        'data_url'
      );
      const configResponse = await this.contentService.getSystemsConfigurationsAsync();
      await this.contentService.saveConfigurations(configResponse);

      const results = await firstValueFrom(
        this.configurationService.getClubRulesAPIData()
      );

      const hasTimeoutError =
        results.clubRulesData?.timedOut;

      if (hasTimeoutError) {
        localStorage.setItem('hasAPIFacedError', 'true');
      }

      if (!results.clubRulesData.error) {
        this.loginDetailsService.setClubRules(results.clubRulesData);
      }

      this.loaderService.setLoaderStateActive(
        false,
        'data_url'
      );


      const response = await this.authService.signIn(
        usernameToUse,
        this.password.value
      );

      if (response && response.success) {
        // await this.contentService.getContentsAndConfigurationsData();
        const givenName = this.localStorageService.getData('playerId');
        if (!PlayerIdValidator.isValid(givenName)) {
          if (this.loginDetailsService.showMfaSetupOnRegistration) {
            this.existingPlayer = false;
            this.userEnteredEmail = decryptEmail || this.loginForm.get('username').value;
            this.isEnableSignUp = false;
            this.isEnableOtp = false;
            this.isEnableMfaSetupDirectly = true;
            this.switchState(LoginState.SignUp);
          } else {
            this.openAccountLinkingFlow();
          }
        }
        // save the player details
        const emailToSave = decryptEmail || this.loginForm.get('username').value;
        this.loginDetailsService.setPlayerUsername(emailToSave);
        if (emailToSave && emailToSave.includes('@')) {
          this.localStorageService.saveData('EMAIL', emailToSave);
          this.localStorageService.saveData('mail', emailToSave);
        }
        this.loginForm.get('username').patchValue(decryptEmail);
        console.log(
          'Decrypted Email set in login form:',
          this.loginForm.get('username').value
        );

        this.userLoginDetails = this.loginForm.value;
        this.userLoginDetails.username =
          this.userLoginDetails?.username?.toLowerCase();
      } else if (response?.mfaChallenge) {
        // Handle MFA challenges
        this.mfaChallengeType = response.mfaChallenge.challengeName;
        this.mfaChallengeParameters = response.mfaChallenge.challengeParameters;
        this.mfaSession = response.mfaChallenge.session;
        this.mfaEmail = decryptEmail || this.loginForm.get('username').value;

        // Store credentials for potential MFA reset flow
        this.mfaResetUsername = usernameToUse;
        this.mfaResetPassword = this.password.value;

        if (this.mfaChallengeType === 'SELECT_MFA_TYPE') {
          // User has both SMS and TOTP enabled - show selection screen
          // Extract phone number if available for the selection screen
          if (this.mfaChallengeParameters && this.mfaChallengeParameters.CODE_DELIVERY_DESTINATION) {
            this.mfaPhoneNumber = this.mfaChallengeParameters.CODE_DELIVERY_DESTINATION;
          }
          this.switchState(LoginState.MfaSelection);
        } else if (this.mfaChallengeType === 'SMS_MFA') {
          // Only SMS MFA - extract phone number from challenge parameters
          this.selectedMfaMethod = 'SMS';
          if (this.mfaChallengeParameters && this.mfaChallengeParameters.CODE_DELIVERY_DESTINATION) {
            this.mfaPhoneNumber = this.mfaChallengeParameters.CODE_DELIVERY_DESTINATION;
          }
          this.switchState(LoginState.MfaOtpVerification);
          this.mfaOtpForm.reset();
        } else if (this.mfaChallengeType === 'SOFTWARE_TOKEN_MFA') {
          // Only TOTP MFA - show OTP input screen
          this.selectedMfaMethod = 'TOTP';
          this.switchState(LoginState.MfaOtpVerification);
          this.mfaOtpForm.reset();
        }
      } else if (response?.newPasswordRequired) {
        // Handle NEW_PASSWORD_REQUIRED challenge
        this.userEnteredEmail = decryptEmail || this.loginForm.get('username').value;
        this.userEnteredPassword = this.loginForm.get('password').value;
        this.switchState(LoginState.NewPasswordRequired);
      } else {
        if (response?.hasAPIFacedError) {
          this.toast.toastErrorMsg('MODULES.LOGIN.SERVER_DOWN_ERROR');
          localStorage.clear();
          localStorage.setItem('hasAPIFacedError', 'true');
          return;
        }
        if (response?.redirect) {
          await this.authService.resendSignUpCode(
            this.username.value,
            this.password.value
          );
          this.loaderService.setLoaderStateActive(false, 'cognito_service_url');
          this.toast.toastSuccess('MODULES.LOGIN.LOGIN_OTP');
          this.switchState(LoginState.SignUp);
          this.userEnteredEmail =
            decryptEmail || this.loginForm.get('username').value;
          this.userEnteredPassword = this.loginForm.get('password').value;
          this.isEnableOtp = true;
          this.isEnableSignUp = false;
        } else if (response.isEmailNotFound) {
          this.switchState(LoginState.EmailConfirmation);
          localStorage.setItem(
            'acc_number',
            this.loginForm.get('username').value
          );
          this.userEnteredEmail =
            decryptEmail || this.loginForm.get('username').value;
          this.userEnteredPassword = this.loginForm.get('password').value;
        } else if (response.isUserDisabled) {
          // this.toast.toastError('MODULES.LOGIN.ACCOUNT_LOCKED_MESSAGE');

          this.dsDialog
            .open(ConfirmationAlertDialogComponent, {
              data: {
                dialogTitle: 'Account Locked',
                dialogMessage: 'Your account got locked due to suspicious activity. Click "Ok" to unlock your account.',
              },
              width: '344px',
              closeButton: false,
            })
            .afterClosed$.subscribe(async (result: string) => {
              if (result === 'Ok') {
                // Use the decrypted email from Cognito lookup if available, otherwise fall back to raw input
                const rawInput = this.loginForm.get('username').value;
                const identifier = decryptEmail || rawInput;
                const isEmail = identifier?.includes('@');
                this.unlockIdentifier = identifier;
                this.isUnlockByEmail = isEmail;
                this.loaderService.setLoaderStateActive(true, 'unlock_otp_generation_service_url');
                try {
                  await this.loginService.generateUnlockOtp(
                    identifier,
                    isEmail,
                    this.selectedLangKey || 'en'
                  );
                  this.loaderService.setLoaderStateActive(false, 'unlock_otp_generation_service_url');
                  this.isAccountUnlockFlow = true;
                  this.existingPlayerOtp = true;
                  this.forgotPasswordInvoked = false;
                  this.changePasswordInvoked = false;
                  this.existingPlayer = false;
                  this.accountlink = false;
                  this.emailId = identifier?.includes('@') ? identifier : '';
                  this.hasPhonenumber = false;
                  this.hasMail = true;
                  this.otpFormExisiting.reset();
                  this.switchState(LoginState.ExistingPlayerLinking);
                } catch {
                  this.loaderService.setLoaderStateActive(false, 'unlock_otp_generation_service_url');
                  this.toast.toastError('MODULES.LOGIN.GENERIC_ERROR');
                }
              } else {
                this.toast.toastError('MODULES.LOGIN.ACCOUNT_LOCKED_MESSAGE');
              }
            });
        }
        // this.loginForm.reset();
      }
    } catch (error: any) {
      // this.loginForm.reset();
    }

    if (this.loginForm.invalid) {
      for (const control of Object.keys(this.loginForm.controls)) {
        this.loginForm.controls[control].markAsTouched();
      }
    }
    this.cdr.detectChanges();
  }

  logOut() {
    // display the confirmation dialog
    this.dsDialog
      .open(ConfirmationAlertDialogComponent, {
        data: {
          dialogTitle: this.toast.gettransloco(
            'MODULES.COMMON.MESSAGES.CONFIRMATION_HEADER'
          ),
          dialogMessage: this.toast.gettransloco(
            'MODULES.COMMON.MESSAGES.CONFIRMATION_MESSAGE'
          ),
        },
        width: '344px',
        closeButton: false,
      })
      .afterClosed$.subscribe((result: string) => {
        if (result === 'Ok') {
          this.isCmsRegistrationPending = false;
          this.existingPlayer = false;
          this.newPlayerRegistrationInvoked = false;
          this.existingPlayerOtp = false;
          this.accountlink = false;
          this.isAccountUnlockFlow = false;
          this.showOTPScreen = false;
          this.isEnableOtp = false;
          this.isEnableSignUp = true;
          this.switchState(LoginState.SignIn);
          this.resetAllForms();
          this.reinit();
          localStorage.clear();
        }
      });
  }

  private async reinit() {
    this.userLoginDetails = { username: '', password: '' };
    await this.authService.logoutSignedInUser();
    this.contentService.resetConfigLoaded();
    await this.contentService.getContentsAndConfigurationsData();

    this.init();
  }

  private generateAccountNumber(email: string): string {
    const now = new Date();
    const timestamp = now.getTime().toString();
    const random = (now.getTime() % 1000000).toString().padStart(6, '0');
    const emailPrefix = email.split('@')[0];
    return `${emailPrefix}_${timestamp}_${random}`;
  }

  backToAccount() {
    if (this.isAccountUnlockFlow) {
      this.isAccountUnlockFlow = false;
      this.showLogin();
      return;
    }
    if (!this.supportOtpValidationForPlayerLinking) {
      this.logOut();
      return;
    }
    this.existingPlayer = true;
    this.existingPlayerOtp = false;
    this.isCmsRegistrationPending = false;
    this.newPlayerRegistrationInvoked = false;
    this.accountlink = false;
    this.accountlinkform.reset();
    this.otpFormExisiting.reset();
    this.isAccountUnlockFlow = false;
  }

  private resetAllForms() {
    this.loginForm.reset();
    this.existingPlayerForm.reset();
    this.accountlinkform.reset();
    this.directAccountLinkForm?.reset();
    this.otpFormExisiting.reset();
    this.isAccountUnlockFlow = false;
  }

  settings() {
    const actionBtn: any = {
      okBtnName: 'ok',
      okBtnClick: 'ok',
      cancelBtnName: 'cancel',
      cancelBtnClick: 'cancel',
    };

    this.dsDialog.open(SettingLoginComponent, {
      data: {
        actionButtons: actionBtn,
      },
      windowClass: 'settingsLogin',
      width: '640px',
      enableClose: true,
      type: eDialogType.Flyout,
    });
  }

  selectedLangKey = '';
  selectedLangText = '';
  selectedLangFlag = '';
  availableLanguages = {
    en: {
      lang: 'English',
      flag: '../../../resources/images/language/us-en.svg',
    },
    es: {
      lang: 'Spanish',
      flag: '../../../resources/images/language/es-es.svg',
    },
  };

  onLangChange(langKey: string) {
    this.selectedLangKey = langKey;
    this.selectedLangText = this.availableLanguages[langKey].lang;
    this.selectedLangFlag = this.availableLanguages[langKey].flag;
  }

  get language() {
    return Object.keys(this.availableLanguages);
  }

  onLoginBGChanged() {
    this.settingHelper.getLoginSignal().subscribe((loginBG) => {
      if (loginBG) {
        this.loginBG = loginBG;
        window.localStorage.setItem('loginBG', JSON.stringify(loginBG));
      }
    });
  }

  getLoginInitData() {
    this.logoData = this.appSettingService.getLoginData();
    let loginData = window.localStorage.getItem('loginBG');
    if (loginData) {
      this.loginBG = JSON.parse(loginData);
    } else {
      this.loginBG = this.logoData.backGroundValues;
    }
  }

  loadRegistration() {
    this.switchState(LoginState.SignUp);
  }

  setForgotPassword() {
    this.forgotPasswordInvoked = true;
    this.switchState(LoginState.ForgotPassword);
  }

  resetPasswordInvoked(resetData: { username: string; maskedEmail: string }) {
    this.forgotPasswordInvoked = false;
    this.changePasswordInvoked = true;
    this.resetPasswordUsername = resetData.username;
    this.maskedEmail = resetData.maskedEmail;
  }

  changePassword() {
    this.changePasswordInvoked = false;
    this.resetPasswordUsername = '';
    this.maskedEmail = '';

    // Reset form and clear validation states
    this.loginForm.reset();
    this.loginForm.markAsUntouched();
    this.loginForm.markAsPristine();

    this.switchState(LoginState.SignIn);
    this.cdr.detectChanges();
  }

  async resendConfirmationCodes() {
    try {
      const { nextStep } = await this.authService.resetPlayerPassword(
        this.resetPasswordUsername
      );

      if (nextStep.resetPasswordStep === 'CONFIRM_RESET_PASSWORD_WITH_CODE') {
        const codeDeliveryDetails = nextStep.codeDeliveryDetails;
        this.toast.toastSuccess(
          `Confirmation code was sent to ${codeDeliveryDetails.destination}`
        );
        this.maskedEmail = codeDeliveryDetails.destination;
      }
    } catch (error) {
      this.toast.toastError(error.message);
    }
  }

  // HANDLE ACCOUNT EMAIL UNLINK
  handleAccountEmailUnlink(value: string) {
    const email = this.loginDetailsService.userName;
    if (value === 'register_step_1') {
      this.switchState(LoginState.SignUp);
      // email ? this.switchState(LoginState.SignUp) : this.switchState(LoginState.SignIn);
    } else if (value === 'register_step_2') {
      const status = {
        isSuccess: true,
        email: email,
      };
      email
        ? this.handleSignupCompleted(status)
        : this.switchState(LoginState.SignIn);
    }
  }

  showLogin() {
    this.existingPlayerOtp = false;
    this.existingPlayer = false;
    this.accountlink = false;
    this.changePasswordInvoked = false;
    this.newPlayerRegistrationInvoked = false;
    this.forgotPasswordInvoked = false;
    this.isAccountUnlockFlow = false;
    this.isEnableOtp = false;
    this.isEnableSignUp = true;
    this.userEnteredEmail = '';
    this.loginForm.reset();

    // Clear validation states to prevent error messages from showing
    this.loginForm.markAsUntouched();
    this.loginForm.markAsPristine();

    this.switchState(LoginState.SignIn);
    this.cdr.detectChanges();
  }

  showOTPPage() {
    this.existingPlayerOtp = true;
    this.existingPlayer = false;
  }

  async resendUnlockOtp() {
    try {
      await this.loginService.generateUnlockOtp(
        this.unlockIdentifier,
        this.isUnlockByEmail,
        this.selectedLangKey || 'en'
      );
      this.toast.toastSuccess('MODULES.LOGIN.LOGIN_OTP');
    } catch {
      this.toast.toastError('MODULES.LOGIN.GENERIC_ERROR');
    }
  }

  showAccountLinkPage() {
    this.accountlink = !this.supportOtpValidationForPlayerLinking;
    this.existingPlayerOtp = this.supportOtpValidationForPlayerLinking;
    this.existingPlayer = false;
    this.changePasswordInvoked = false;
    this.newPlayerRegistrationInvoked = false;
    this.forgotPasswordInvoked = false;
  }

  async handleEmailConfirmed(data: { email: string; password: string; accountNumber: string }) {
    // Store the confirmed email and password
    this.userEnteredEmail = data.email;
    this.userEnteredPassword = data.password;

    // Send OTP to the confirmed email
    try {
      this.authService
        .sendOtp(data.email, data.password, data.accountNumber)
        .subscribe(() => {
          this.loaderService.setLoaderStateActive(false, 'cognito_service_url');
          this.toast.toastSuccess('MODULES.LOGIN.LOGIN_OTP');

          // Switch to signup component with OTP screen enabled
          this.switchState(LoginState.SignUp);
          this.isEnableOtp = true;
          this.isEnableSignUp = false;
          this.isEmailConfirmationFlow = true;
        });
    } catch (error) {
      console.error('Failed to send OTP:', error);
    }
  }

  handleShowVerifyDetails(accountNumber: string) {
    this.userEnteredEmail = accountNumber;
    this.forgotPasswordInvoked = false;
    this.switchState(LoginState.VerifyDetails);
  }

  async handleShowAccountLock(data: { identifier: string; isEmail: boolean }) {
    this.dsDialog
      .open(ConfirmationAlertDialogComponent, {
        data: {
          dialogTitle: 'Account Locked',
          dialogMessage: 'Your account got locked due to suspicious activity. Click "Ok" to unlock your account.',
        },
        width: '344px',
        closeButton: false,
      })
      .afterClosed$.subscribe(async (result: string) => {
        if (result === 'Ok') {
          const { identifier, isEmail } = data;
          this.unlockIdentifier = identifier;
          this.isUnlockByEmail = isEmail;
          try {
            await this.loginService.generateUnlockOtp(
              identifier,
              isEmail,
              this.selectedLangKey || 'en'
            );
            this.isAccountUnlockFlow = true;
            this.existingPlayerOtp = true;
            this.forgotPasswordInvoked = false;
            this.changePasswordInvoked = false;
            this.existingPlayer = false;
            this.accountlink = false;
            this.emailId = identifier?.includes('@') ? identifier : '';
            this.hasPhonenumber = false;
            this.hasMail = true;
            this.otpFormExisiting.reset();
            this.switchState(LoginState.ExistingPlayerLinking);
          } catch {
            this.toast.toastError('MODULES.LOGIN.GENERIC_ERROR');
          }
        } else {
          this.toast.toastError('MODULES.LOGIN.ACCOUNT_LOCKED_MESSAGE');
        }
      });
  }

  handleShowOtpVerification(data: { username: string; maskedEmail: string }) {
    // Store the username and email for OTP verification
    this.userEnteredEmail = data.maskedEmail;
    this.emailShow = data.maskedEmail;

    // Hide forgot password screen and show OTP verification screen
    this.forgotPasswordInvoked = false;

    // Set flag to indicate this is OTP verification only (no auto-login)
    this.isOtpVerificationOnly = true;

    // Switch to signup component with OTP screen enabled
    this.switchState(LoginState.SignUp);
    this.isEnableOtp = true;
    this.isEnableSignUp = false;
  }

  async handleVerificationCompleted(data: {
    accountNumber: string;
    dateOfBirth: string;
    zipCode: string;
  }) {
    try {
      // Validate user information via API

      let encryptedDOB = await this.authService.encryptAes256Gcm(
        data.dateOfBirth,
        encryptionKey
      );
      let encryptedZip = await this.authService.encryptAes256Gcm(
        data.zipCode,
        encryptionKey
      );
      const payload = {
        dob: encryptedDOB,
        pincode: encryptedZip,
        accountNumber: data.accountNumber,
      };

      await this.contentService.getContentsAndConfigurationsData();

      const response: any = await this.loginService.validateUserInfo(payload);

      // Check if validation was successful
      if (response && response.message === 'User info matched successfully') {
        this.resetPasswordUsername = data.accountNumber;
        this.switchState(LoginState.SetPassword);
      } else {
        this.toast.toastError(
          'ERRORS.VERIFICATION_FAILED'
        );
      }
    } catch (error) {
      const displayError =
        error.error?.message ||
        error.message ||
        'ERRORS.VERIFICATION_FAILED';
      this.toast.toastError(displayError);
    }
  }

  handlePasswordReset(data: { email: string; password: string }) {
    this.userEnteredEmail = data.email;
    this.userEnteredPassword = data.password;
    this.isEnableOtp = true;
    this.isEnableSignUp = false;
    this.isPasswordResetFlow = true;
    this.switchState(LoginState.SignUp);
  }

  // MFA Methods
  selectMfaMethod(method: 'SMS' | 'TOTP') {
    this.selectedMfaMethod = method;
  }

  async proceedWithMfaMethod() {
    if (!this.selectedMfaMethod) {
      this.toast.toastError('MODULES.LOGIN.SELECT_MFA_METHOD');
      return;
    }

    try {
      const result = await this.authService.selectMfaType(this.selectedMfaMethod);

      // Update phone number if SMS was selected and a new phone number was returned
      // (it may already be set from the initial SELECT_MFA_TYPE challenge)
      if (this.selectedMfaMethod === 'SMS' && result.phoneNumber) {
        this.mfaPhoneNumber = result.phoneNumber;
      }

      // Move to OTP verification screen
      this.switchState(LoginState.MfaOtpVerification);
      this.mfaOtpForm.reset();
    } catch (error: any) {
      const errorMessage = error?.message || 'MODULES.LOGIN.GENERIC_ERROR';
      this.toast.toastError(errorMessage);
    }
  }

  async submitMfaOtp() {
    if (!this.mfaOtpForm.valid) {
      this.toast.toastError('MODULES.LOGIN.OTP_ENTERY');
      return;
    }

    const otp1 = this.mfaOtpForm.controls['otp1']?.value;
    const otp2 = this.mfaOtpForm.controls['otp2']?.value;
    const otp3 = this.mfaOtpForm.controls['otp3']?.value;
    const otp4 = this.mfaOtpForm.controls['otp4']?.value;
    const otp5 = this.mfaOtpForm.controls['otp5']?.value;
    const otp6 = this.mfaOtpForm.controls['otp6']?.value;

    const otpCode = `${otp1}${otp2}${otp3}${otp4}${otp5}${otp6}`;

    try {
      const result = await this.authService.confirmMfaSignIn(otpCode, this.selectedMfaMethod);

      if (result.success) {
        this.toast.toastSuccess('MODULES.LOGIN.LOGIN_SUCCESS');
        this.mfaOtpForm.reset();
        // Navigation handled by authService
      } else {
        this.toast.toastError('MODULES.LOGIN.INVALID_OTP');
      }
    } catch (error: any) {
      const errorMessage = error?.message || 'MODULES.LOGIN.INVALID_OTP';
      this.toast.toastError('MODULES.ACCOUNT_SECURITY.MFA.TOTP_INVALID_OTP');
    }
  }

  cancelMfa() {
    this.mfaOtpForm.reset();
    this.mfaChallengeType = '';
    this.mfaChallengeParameters = {};
    this.mfaSession = '';
    this.mfaPhoneNumber = '';
    this.selectedMfaMethod = 'SMS';
    this.loginForm.reset();

    // Clear validation states to prevent error messages from showing
    this.loginForm.markAsUntouched();
    this.loginForm.markAsPristine();

    this.switchState(LoginState.SignIn);
    this.cdr.detectChanges();
  }

  async turnOffMfa(): Promise<void> {
    try {
      // Get the user's email/account number - try from loginDetailsService first, fallback to form
      let identifier = this.loginDetailsService.userName || this.username.value;

      // If still not available, try to fetch from Cognito
      if (!identifier) {
        const userAttributes = await this.authService.getPlayerUserAttributes();
        identifier = userAttributes['email'];
      }

      if (!identifier) {
        this.toast.toastError('MODULES.LOGIN.EMAIL_NOT_FOUND');
        return;
      }

      this.loaderService.setLoaderStateActive(true, 'mfa_reset_generate_otp');

      // Detect if identifier is email or account number
      const isEmail = identifier.includes('@');
      const email = isEmail ? identifier : '';
      const accountNumber = !isEmail ? identifier : '';

      // Generate OTP for MFA reset
      const response = await this.loginService.generateMfaResetOtp(email, accountNumber);

      this.loaderService.setLoaderStateActive(false, 'mfa_reset_generate_otp');

      if (response) {
        // Store the identifier for validation
        this.mfaResetEmail = response.email;

        // Reset the OTP form
        this.mfaResetOtpForm.reset();

        // Show OTP verification screen
        this.switchState(LoginState.MfaResetOtp);

        this.toast.toastSuccess('MODULES.LOGIN.OTP_SENT_TO_EMAIL_MFA_TOAST');
      } else {
        this.toast.toastError('MODULES.LOGIN.OTP_GENERATION_FAILED');
      }
    } catch (error: any) {
      this.loaderService.setLoaderStateActive(false, 'mfa_reset_generate_otp');
      const errorMessage = error?.message || 'MODULES.LOGIN.MFA_RESET_OTP_ERROR';
      this.toast.toastError(errorMessage);
    }
  }

  async submitMfaResetOtp(): Promise<void> {
    if (!this.mfaResetOtpForm.valid) {
      this.toast.toastError('MODULES.LOGIN.ENTER_VALID_CODE');
      return;
    }

    const otp1 = this.mfaResetOtpForm.controls['otp1']?.value;
    const otp2 = this.mfaResetOtpForm.controls['otp2']?.value;
    const otp3 = this.mfaResetOtpForm.controls['otp3']?.value;
    const otp4 = this.mfaResetOtpForm.controls['otp4']?.value;
    const otp5 = this.mfaResetOtpForm.controls['otp5']?.value;
    const otp6 = this.mfaResetOtpForm.controls['otp6']?.value;

    if (!otp1 || !otp2 || !otp3 || !otp4 || !otp5 || !otp6) {
      this.toast.toastError('MODULES.LOGIN.OTP_ENTERY');
      return;
    }

    const otpCode = `${otp1}${otp2}${otp3}${otp4}${otp5}${otp6}`;

    // Detect if identifier is email or account number
    const isEmail = this.mfaResetEmail.includes('@');

    this.loaderService.setLoaderStateActive(true, 'mfa_reset_validate_otp');
    try {
      // Step 1: Validate OTP
      await this.loginService.validateMfaResetOtp(
        otpCode,
        this.mfaResetEmail,
        isEmail
      );

      // Step 2: Sign in the user to get authenticated session
      if (!this.mfaResetUsername || !this.mfaResetPassword) {
        throw new Error('Missing credentials for re-authentication');
      }

      const signInResponse = await this.authService.signIn(
        this.mfaResetUsername,
        this.mfaResetPassword
      );

      // If sign-in triggers MFA again, handle it
      if (signInResponse?.mfaChallenge) {
        this.loaderService.setLoaderStateActive(false, 'mfa_reset_validate_otp');
        this.toast.toastWarning('MODULES.LOGIN.MFA_RESET_CONTACT_SUPPORT');
        this.switchState(LoginState.SignIn);
        return;
      }

      // Verify sign-in was actually successful
      if (!signInResponse || !signInResponse.success) {
        throw new Error('Authentication failed. Cannot disable MFA without valid session.');
      }

      // Step 3: Now disable MFA in Cognito (user is authenticated)
      await this.authService.disableAllMfa();

      this.loaderService.setLoaderStateActive(false, 'mfa_reset_validate_otp');

      // Clear MFA-related data
      this.mfaOtpForm.reset();
      this.mfaResetOtpForm.reset();
      this.mfaChallengeType = '';
      this.mfaChallengeParameters = {};
      this.mfaSession = '';
      this.mfaPhoneNumber = '';
      this.mfaResetEmail = '';
      this.mfaResetUsername = '';
      this.mfaResetPassword = '';
      this.selectedMfaMethod = 'SMS';

      // Show success message
      this.toast.toastSuccess('MODULES.LOGIN.MFA_DISABLED_SUCCESS');

      // User is now logged in with MFA disabled - navigate to dashboard
      // (navigation handled automatically by signIn method)
    } catch (error: any) {
      this.loaderService.setLoaderStateActive(false, 'mfa_reset_validate_otp');
      const msg = error?.message || error?.error?.message || 'MODULES.LOGIN.OTP_VALIDATION_ERROR';
      this.toast.toastError('MODULES.LOGIN.TOTP_INVALID_OTP_MFA_TOAST');

      // Reset OTP inputs on error
      this.mfaResetOtpForm.reset();
    }
  }


  cancelMfaReset(): void {
    this.mfaResetOtpForm.reset();
    this.mfaResetEmail = '';
    // Go back to MFA OTP verification screen
    this.switchState(LoginState.MfaOtpVerification);
  }

  async submitNewPassword(): Promise<void> {
    if (!this.newPasswordForm.valid) {
      this.newPasswordForm.markAllAsTouched();
      if (this.newPasswordForm.hasError('passwordMismatch')) {
        this.toast.toastError('Passwords do not match');
      } else {
        this.toast.toastError('Please fill in all required fields correctly');
      }
      return;
    }

    const newPassword = this.newPasswordForm.get('newPassword')?.value;
    const oldPassword = this.userEnteredPassword;

    try {
      this.loaderService.setLoaderStateActive(true, 'cognito_service_url');

      let encryptedOldPassword = await this.authService.encryptAes256Gcm(oldPassword, encryptionKey);
      let encryptedNewPassword = await this.authService.encryptAes256Gcm(newPassword, encryptionKey);


      // Update password using Cognito's updatePassword API
      await this.authService.updatePlayerPassword({
        oldPassword: encryptedOldPassword,
        newPassword: encryptedNewPassword
      });

      // Update migration status to mark migration as completed
      await this.authService.updateMigrationStatus();

      this.toast.toastSuccess('MODULES.ACCOUNT_SECURITY.CHANGE_PASSWORD_LABELS.MESSAGES.PASSWORD_SUCCESSFULLY_CHANGED');

      // Session details were already stored during sign-in, just navigate
      this.authService.navigateToDashboard();

    } catch (error: any) {
      console.error('Error setting new password:', error);
      const errorMessage = error?.message || 'Failed to set new password';
      this.toast.toastError(errorMessage);
    } finally {
      this.loaderService.setLoaderStateActive(false, 'cognito_service_url');
    }
  }

  async cancelNewPassword(): Promise<void> {
    // Log out the user to clear any session state
    await this.authService.logoutSignedInUser();

    // Reset all forms and state
    this.newPasswordForm.reset();
    this.loginForm.reset();

    // Clear validation states to prevent error messages from showing
    this.loginForm.markAsUntouched();
    this.loginForm.markAsPristine();

    this.userEnteredEmail = '';
    this.userEnteredPassword = '';
    this.newPasswordUsername = '';

    // Switch back to sign-in
    this.switchState(LoginState.SignIn);

    // Trigger change detection
    this.cdr.detectChanges();
  }

  get maskedMfaPhoneNumber(): string {
    // The phone number from Cognito is already masked (e.g., "+********6292")
    // so we can return it directly
    return this.mfaPhoneNumber || '';
  }

  get maskedMfaResetEmail(): string {
    const identifier = this.mfaResetEmail;
    if (!identifier || typeof identifier !== 'string') {
      return this.maskedEmailId || '';
    }

    // Check if it's an email (contains @)
    if (identifier.includes('@')) {
      const [name, domain] = identifier.split('@');
      if (!name || !domain) return identifier;
      const maskedName =
        name.length <= 2
          ? name[0] + '*'
          : name.length === 3
            ? name[0] + '*' + name[2]
            : name[0] + '*'.repeat(name.length - 3) + name.slice(-2);
      return `${maskedName}@${domain}`;
    }

    // It's an account number - mask all but last 4 digits
    const len = identifier.length;
    if (len <= 4) {
      return '*'.repeat(len);
    }
    return '*'.repeat(len - 4) + identifier.slice(-4);
  }
}
